export const REDIRECT_AFTER_SIGN_IN_KEY = "redirectAfterSignIn";

export const REDIRECT_PATHS_TO_EXCLUDE = ["/sign-in", "/set-password"];

export function shouldPersistRedirectPath(isSignedIn, pathname) {
  return !isSignedIn && pathname && !REDIRECT_PATHS_TO_EXCLUDE.includes(pathname);
}

export function buildRedirectTarget(pathname, search = "") {
  return `${pathname || ""}${search || ""}`;
}

export function normalizeStoredRedirectPath(raw) {
  return raw && raw !== "/sign-in" ? raw : "/";
}

export function shouldClearStoredRedirectAfterArrival(pathname, search, stored) {
  if (!stored || stored === "/sign-in") {
    return false;
  }
  const current = buildRedirectTarget(pathname, search);
  return current === stored;
}

export function resolvePostSignInNavigation(pathname, search, stored) {
  if (!stored || stored === "/sign-in" || stored === "/") {
    return null;
  }
  const current = buildRedirectTarget(pathname, search);
  if (current === stored) {
    return { action: "clear" };
  }
  return { action: "navigate", target: stored };
}

export function applyRedirectAfterSignInSideEffects({
  isSignedIn,
  userRole,
  isPasswordEnabled,
  pathname,
  search,
  storage,
  navigate,
  removeHypercomplyAuth = true,
}) {
  if (!isSignedIn) {
    if (shouldPersistRedirectPath(isSignedIn, pathname)) {
      storage.setItem(REDIRECT_AFTER_SIGN_IN_KEY, buildRedirectTarget(pathname, search));
    }
    if (removeHypercomplyAuth) {
      storage.removeItem("hypercomplyauth");
    }
    return;
  }

  if (!userRole || isPasswordEnabled !== true) {
    return;
  }

  const stored = storage.getItem(REDIRECT_AFTER_SIGN_IN_KEY);
  const nextStep = resolvePostSignInNavigation(pathname, search, stored);
  if (nextStep?.action === "clear") {
    storage.removeItem(REDIRECT_AFTER_SIGN_IN_KEY);
    return;
  }
  if (nextStep?.action === "navigate") {
    storage.removeItem(REDIRECT_AFTER_SIGN_IN_KEY);
    navigate(nextStep.target, { replace: true });
  }
}
